export const SAVED = 'Отложить';
export const SAVE = 'Отложено';


// WEBPACK FOOTER //
// ./src/pages/event/card/button-deferred/const.ts